import { createContext } from "react";
import type {
  AuthUser,
  ChangePasswordResponse,
  LoginResult,
  RegisterOrganizationRequest,
  RegisterOrganizationResponse,
} from "@/services/authService";

/**
 * Тип контекста аутентификации.
 */
export interface AuthContextType {
  isAuthenticated: boolean;
  user: AuthUser | null;
  login: (email: string, password: string, totpCode: string) => Promise<boolean>;
  loginWithResult: (email: string, password: string, totpCode: string) => Promise<LoginResult>;
  changePassword: (
    currentPassword: string,
    newPassword: string,
    confirmPassword: string,
  ) => Promise<ChangePasswordResponse>;
  register: (data: RegisterOrganizationRequest) => Promise<RegisterOrganizationResponse>;
  logout: () => void;
  isLoading: boolean;
}

/**
 * Контекст аутентификации.
 *
 * Вынесен в отдельный файл, чтобы React Fast Refresh корректно работал.
 */
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
